// extracted by mini-css-extract-plugin
export default {"bar":"ProgressBar_bar__hO69G","fallback":"ProgressBar_fallback__f25-i","fallbackbar":"ProgressBar_fallbackbar__USESx"};